<div id="agenda-popup" class="common-company-popup popup-md">
    <form class="form" role="form" autocomplete="off" [formGroup]="agendaForm">
        <div class="popoup-hearder">
            <h2 class="m-b-5" mat-dialog-title>Agenda</h2>
        </div>
        <div class="popoup-content">
            <div class="block-looper">
                <div class="form-wrap w20">
                    <mat-label aria-label="" class="label">Fecha</mat-label>
                    <mat-form-field appearance="fill">
                        <input matInput [matDatepicker]="picker" formControlName="Fecha">
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>
                    <mat-error *ngIf="agendaForm.get('Fecha').invalid && agendaForm.get('Fecha').touched">
                        <span *ngIf="agendaForm.get('Fecha').hasError('required')"> La fecha es obligatoria</span>
                    </mat-error>
                </div>
                <div class="form-wrap w80">
                    <mat-label aria-label="" class="label">Asunto</mat-label>
                    <mat-form-field appearance="fill">
                        <input type="text" matInput formControlName="Asunto" maxlength="100">
                    </mat-form-field>
                    <mat-error *ngIf="agendaForm.get('Asunto').invalid && agendaForm.get('Asunto').touched">
                        <span *ngIf="agendaForm.get('Asunto').hasError('required')"> El asunto es obligatorio</span>
                    </mat-error>
                </div>
                <div class="form-wrap">
                    <mat-label aria-label="" class="label">Texto</mat-label>
                    <mat-form-field appearance="fill">
                        <textarea matInput placeholder="" rows="4" formControlName="Texto"></textarea>
                    </mat-form-field>
                    <mat-error *ngIf="agendaForm.get('Texto').invalid && agendaForm.get('Texto').touched">
                        <span *ngIf="agendaForm.get('Texto').hasError('required')"> El texto es obligatorio</span>
                    </mat-error>
                </div>
            </div>
        </div>
        <div class="popoup-footer">
            <button class="keep" (click)="onSubmit()"><span class="mat-button-wrapper">Guardar</span></button>
            <button class="cancel" (click)="cancel(false)"><span class="mat-button-wrapper">Cancelar</span></button>
        </div>
    </form>
</div>